<div #reportContainer id="report-destination" class="dynamic-height"></div>
